import React from "react";
import { thumbnailLimitDesktop, thumbnailLimitTablet, thumbnailLimitMobile } from "../UserPhotosAndVideos";
interface MediaReviewThumbnailOverlayProps {
  totalMediaReviews: number;
  showRemainingOverlayMobile?: boolean;
  showRemainingOverlayTablet?: boolean;
  showRemainingOverlayDesktop?: boolean;
  filterByRatingEnabled?: boolean;
}
const MediaReviewThumbnailOverlay = ({
  totalMediaReviews,
  showRemainingOverlayMobile,
  showRemainingOverlayTablet,
  showRemainingOverlayDesktop,
  filterByRatingEnabled = false
}: MediaReviewThumbnailOverlayProps) => {
  const totalRemainingMediaReviewsMobile = totalMediaReviews - thumbnailLimitMobile;
  const totalRemainingMediaReviewsTablet = totalMediaReviews - thumbnailLimitTablet;
  const totalRemainingMediaReviewsDesktop = totalMediaReviews - thumbnailLimitDesktop;
  return <>
      {filterByRatingEnabled && showRemainingOverlayMobile && <div className="xs:hidden">
          <div className="absolute z-20 w-full h-full bg-gray-800 opacity-45 mix-blend-multiply" />
          <div className={`isolate absolute z-30 w-full h-full text-white text-lg ${totalRemainingMediaReviewsMobile.toString().length > 2 ? "lt:text-sm xl:text-lg" : ""} font-bold flex justify-center items-center`}>
            +{totalRemainingMediaReviewsMobile}
          </div>
        </div>}
      {filterByRatingEnabled && showRemainingOverlayTablet && <div className="lt:hidden">
          <div className="absolute z-20 w-full h-full bg-gray-800 opacity-45 mix-blend-multiply" />
          <div className={`isolate absolute z-30 w-full h-full text-white text-lg ${totalRemainingMediaReviewsTablet.toString().length > 2 ? "lt:text-sm xl:text-lg" : ""} font-bold flex justify-center items-center`}>
            +{totalRemainingMediaReviewsTablet}
          </div>
        </div>}
      {showRemainingOverlayDesktop && <>
          <div className="absolute z-20 w-full h-full bg-gray-800 opacity-45 mix-blend-multiply" />
          <div className={`isolate absolute z-30 w-full h-full text-white text-lg ${totalRemainingMediaReviewsDesktop.toString().length > 2 ? "lt:text-sm xl:text-lg" : ""} font-bold flex justify-center items-center`}>
            +{totalRemainingMediaReviewsDesktop}
          </div>
        </>}
    </>;
};
export default MediaReviewThumbnailOverlay;